import { useDispatch } from "react-redux";
import { AppDispatch } from "../store";

import { Link as RouterLink } from "react-router-dom";
import { ReactNode } from "react";

import { Grid, Typography, Link, Paper, CardContent, Box } from "@mui/material";
import { ArrowBackOutlined } from "@mui/icons-material";

import bgImage from "../assets/images/background-login.png";

/* PROPS INTERFACE */
type AuthLayoutProps = {
  children: ReactNode; // Esto define el tipo de `children`
  title: string;
  linkTo: string;
};

import logoTicoTicket from "../assets/images/logoticoticket.png";

export const AuthLayout = ({ children, linkTo, title }: AuthLayoutProps) => {
  return (
    <Box
      sx={{
        paddingTop: 2,
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
      }}
    >
      <Grid item display={"flex"} xs={12} alignItems={"top"} sx={{}}>
        <ArrowBackOutlined
          sx={{
            ml: { xs: 2, sm: 2 },
            mr: 1,
            color: "primary.main",
          }}
        />

        <Typography
          variant="h6"
          noWrap
          component={RouterLink}
          to={`/`}
          sx={{
            mb: 2,
            fontWeight: 400,
            letterSpacing: ".1rem",
            color: "primary.main",
            textDecoration: "line",
            fontSize: "1rem",
          }}
        >
          Volver al inicio
        </Typography>
      </Grid>

      <Grid
        container
        component="main"
        alignItems="center"
        justifyContent="center"
        sx={{
          zIndex: 1,
          padding: "10px",
        }}
      >
        <Grid item sx={{ width: "660px", maxWidth: "100%" }}>
          <Paper
            sx={{
              borderRadius: 3,
              color: "white",
              backgroundClip: "rgba(26,20,35, 0.9)",
              borderBottom: "2px rgba(40,40,40,0.35) solid",
              borderRight: "2px rgba(40,40,40,0.35) solid",
              backgroundColor: "rgba(23, 16, 35, 0.9)",
              paddingX: { xs: "10px", md: "80px", },
              paddingY: { xs: "40px", md: "60px", },
            }}
            elevation={6}
          >
            <Grid container justifyContent="center" mb={2}>
              <Box
                component={RouterLink}
                to={`/`}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textDecoration: "none",
                }}
              >
                <img
                  src={logoTicoTicket}
                  alt="TicoTicket Logo"
                  style={{
                    height: "30px",
                    width: "auto",
                    marginBottom: 20,
                  }}
                />
              </Box>
            </Grid>

            <CardContent
              sx={{
                px: { xs: 2, md: 3, lg: 4 },
                pb: 2,
              }}
            >
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  color={"text.primary"}
                  sx={{
                    
                    fontWeight: 700,
                    fontSize: 40,
                    display: "inline",
                  }}
                >
                  {title}
                </Typography>
              </Grid>

              <Grid item xs={12} textAlign={"left"} sx={{ mt: 1, mb: 5 }}>
                <Typography
                  color={"text.primary"}
                  sx={{
                    display: "inline",
                    fontSize: 16,
                   
                  }}
                >
                  {linkTo === "register"
                    ? "Introduzca sus datos para acceder"
                    : "Llena los datos a continuación"}
                </Typography>
              </Grid>

              {children}

              <Grid container justifyContent="center">
                {linkTo !== "reset-password" ? (
                  <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                    ¿{linkTo === "register" ? "Aún no" : "Ya"} tienes una
                    cuenta?{" "}
                    <Link
                      component={RouterLink}
                      to={`/auth/${linkTo}`}
                      color="text.primary"
                      sx={{
                        fontWeight: 700,
                        display: "inline",
                      }}
                    >
                      {linkTo === "register" ? "Regístrate" : "Ingresa"} aquí
                    </Link>
                  </Typography>
                ) : null}
              </Grid>
            </CardContent>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
